const OneTrust = {
	CATEGORY: {
		NECESSARY: "1",
		PERFORMANCE: "2",
		FUNCTIONAL: "3",
		ADVERTISING: "4",
	},
	loadJS: (url, category) => {
		window.oneTrustLoadJS(url, category);
	},
};

export default OneTrust;



// WEBPACK FOOTER //
// ./src/shared/util/oneTrust.js